export enum PlanListInteractions {
  NavigateToList = 'navigate_to_list',
}
